import { SearchPage } from 'Components'
import TemplateSearchPage from 'Stores/_default-store/Templates/SearchPage.rt'
import TemplateMainContent from 'Stores/la-design-concepts/Templates/MainContent.rt'
import { FacetPanel } from 'Components'
import TemplateFacetPanelContainer from 'Stores/_default-store/Templates/FacetPanelContainer.rt'
import { FacetTiles } from 'Components'
import TemplatefacetTileshierarchicalContainer from 'Stores/_default-store/Templates/facetTiles/hierarchicalContainer.rt'
import { SearchHeader } from 'Components'
import { SearchResult } from 'Components'
import { FilterSearchBox } from 'Components'
import { SearchBox } from 'Components'
import TemplateSearchBox from 'Stores/_default-store/Templates/SearchBox.rt'
import TemplateFacetButton from 'Stores/la-design-concepts/Templates/FacetButton.rt'
import { SearchBoxDialogButton } from 'Components'
import TemplatesearchBoxdialogButtonMobile from 'Stores/_default-store/Templates/searchBox/dialogButtonMobile.rt'
import { SearchBoxDialog } from 'Components'
import TemplateSearchBoxDialog from 'Stores/_default-store/Templates/SearchBoxDialog.rt'
import { FacetDialog } from 'Components'
import TemplateFacetDialog from 'Stores/_default-store/Templates/FacetDialog.rt'
import { SimpleColorPaletteDialog } from 'Components'
import TemplatecolorSearchsimplePaletteDialog from 'Stores/_default-store/Templates/colorSearch/simplePaletteDialog.rt'
import { ColorExtractorDialog } from 'Components'
import TemplatecolorSearchcolorExtractorDialog from 'Stores/_default-store/Templates/colorSearch/colorExtractorDialog.rt'

export const compMap = {
  SearchPage,
FacetPanel,
FacetTiles,
SearchHeader,
SearchResult,
FilterSearchBox,
SearchBox,
SearchBoxDialogButton,
SearchBoxDialog,
FacetDialog,
SimpleColorPaletteDialog,
ColorExtractorDialog
} 
export const tplMap = {
  'SearchPage': TemplateSearchPage,
'MainContent': TemplateMainContent,
'FacetPanelContainer': TemplateFacetPanelContainer,
'facetTiles/hierarchicalContainer': TemplatefacetTileshierarchicalContainer,
'SearchBox': TemplateSearchBox,
'FacetButton': TemplateFacetButton,
'searchBox/dialogButtonMobile': TemplatesearchBoxdialogButtonMobile,
'SearchBoxDialog': TemplateSearchBoxDialog,
'FacetDialog': TemplateFacetDialog,
'colorSearch/simplePaletteDialog': TemplatecolorSearchsimplePaletteDialog,
'colorSearch/colorExtractorDialog': TemplatecolorSearchcolorExtractorDialog
};